// Third party
import {
  UserSessionRefreshMutation,
  UserSessionRefreshDocument,
  UserSessionRefreshInput,
} from '@gql';

// Utils
import { createApolloClient } from '../apollo-node-client';

export const imperativeServerUserRefreshSessionMutation = async (
  input: UserSessionRefreshInput
) => {
  const apolloClient = createApolloClient();

  const response = await apolloClient.mutate<UserSessionRefreshMutation>({
    ...{ mutation: UserSessionRefreshDocument, variables: { input } },
  });

  return response;
};
